import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import Header from '../shared/Header/Header';
import { privacyPolicyStyles } from './PrivacyPolicy.styles';

const PrivacyPolicy = () => {
  const styles = privacyPolicyStyles;

  return (
    <Box sx={styles.container}>
      <Box sx={styles.headerContainer}>
        <Header />
      </Box>

      <Box sx={styles.contentContainer}>
        <Typography sx={styles.title}>Privacy Policy</Typography>

        <Box sx={styles.section}>
          <Typography sx={styles.heading}>Royal Vista Vacation Homes Co. LLC</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0.5 }}>
            <Typography sx={styles.text}>Last Updated:</Typography>
            <Typography sx={styles.boldText}>10/11/2025</Typography>
          </Box>

          <Typography sx={styles.text}>
            Royal Vista respects your privacy and is committed to protecting your personal information in accordance
            with UAE data protection laws.
          </Typography>
          <Typography sx={styles.text}>
            This Privacy Policy explains how we collect, use, and protect your personal information.
          </Typography>
        </Box>

        <Box sx={styles.section}>
          <Typography sx={styles.numberedHeading}>1. Information We Collect</Typography>

          <Box sx={styles.subsection}>
            <Typography sx={styles.subheading2}>Personal Information</Typography>
            <Box component="ul" sx={styles.list}>
              <li><Typography component="span" sx={styles.listItem}>Full name</Typography></li>
              <li><Typography component="span" sx={styles.listItem}>Email address</Typography></li>
              <li><Typography component="span" sx={styles.listItem}>Phone number</Typography></li>
              <li><Typography component="span" sx={styles.listItem}>Nationality</Typography></li>
              <li><Typography component="span" sx={styles.listItem}>Passport or Emirates ID details</Typography></li>
            </Box>
          </Box>

          <Box sx={styles.subsection}>
            <Typography sx={styles.subheading2}>Booking Information</Typography>
            <Box component="ul" sx={styles.list}>
              <li><Typography component="span" sx={styles.listItem}>Arrival and departure dates</Typography></li>
              <li><Typography component="span" sx={styles.listItem}>Number of guests</Typography></li>
              <li><Typography component="span" sx={styles.listItem}>Payment information</Typography></li>
            </Box>
          </Box>

          <Box sx={styles.subsection}>
            <Typography sx={styles.subheading2}>Website Usage Data</Typography>
            <Box component="ul" sx={styles.list}>
              <li><Typography component="span" sx={styles.listItem}>IP address</Typography></li>
              <li><Typography component="span" sx={styles.listItem}>Browser type</Typography></li>
              <li><Typography component="span" sx={styles.listItem}>Cookies and usage analytics</Typography></li>
            </Box>
          </Box>
        </Box>

        <Box sx={styles.section}>
          <Typography sx={styles.numberedHeading}>2. Why We Collect Your Information</Typography>
          <Typography sx={styles.text}>
            We collect personal data to:
          </Typography>
          <Box component="ul" sx={styles.list}>
            <li><Typography component="span" sx={styles.listItem}>Process reservations</Typography></li>
            <li><Typography component="span" sx={styles.listItem}>Verify guest identity</Typography></li>
            <li><Typography component="span" sx={styles.listItem}>Comply with Dubai Holiday Homes regulations</Typography></li>
            <li><Typography component="span" sx={styles.listItem}>Register guests with Dubai authorities</Typography></li>
            <li><Typography component="span" sx={styles.listItem}>Improve our services</Typography></li>
            <li><Typography component="span" sx={styles.listItem}>Communicate booking details</Typography></li>
          </Box>
        </Box>

        <Box sx={styles.section}>
          <Typography sx={styles.numberedHeading}>3. Legal Compliance with Dubai Authorities</Typography>
          <Typography sx={styles.text}>
            As a licensed Holiday Homes operator, Royal Vista is required to share guest information with the Dubai
            Department of Economy and Tourism (DET) for regulatory compliance.
          </Typography>
          <Typography sx={styles.text}>
            This information is used solely for official registration purposes.
          </Typography>
        </Box>

        <Box sx={styles.section}>
          <Typography sx={styles.numberedHeading}>4. Payment Information</Typography>
          <Typography sx={styles.text}>
            Payment processing is handled by secure third-party payment gateways.
          </Typography>
          <Typography sx={styles.text}>
            Royal Vista does not store full credit card details on its servers.
          </Typography>
        </Box>

        <Box sx={styles.section}>
          <Typography sx={styles.numberedHeading}>5. Data Security</Typography>
          <Typography sx={styles.text}>
            We implement appropriate security measures to protect your personal data from unauthorized access,
            misuse, or disclosure.
          </Typography>
        </Box>

        <Box sx={styles.section}>
          <Typography sx={styles.numberedHeading}>6. Data Sharing</Typography>
          <Typography sx={styles.text}>
            Your information may be shared with:
          </Typography>
          <Box component="ul" sx={styles.list}>
            <li><Typography component="span" sx={styles.listItem}>Government authorities when legally required</Typography></li>
            <li><Typography component="span" sx={styles.listItem}>Payment processors</Typography></li>
            <li><Typography component="span" sx={styles.listItem}>Property management service providers</Typography></li>
          </Box>
          <Typography sx={styles.text}>
            Royal Vista does not sell or rent personal data to third parties.
          </Typography>
        </Box>

        <Box sx={styles.section}>
          <Typography sx={styles.numberedHeading}>7. Cookies</Typography>
          <Typography sx={styles.text}>
            Our website may use cookies to:
          </Typography>
          <Box component="ul" sx={styles.list}>
            <li><Typography component="span" sx={styles.listItem}>Improve website functionality</Typography></li>
            <li><Typography component="span" sx={styles.listItem}>Analyze visitor behavior</Typography></li>
            <li><Typography component="span" sx={styles.listItem}>Enhance the booking experience</Typography></li>
          </Box>
          <Typography sx={styles.text}>
            You may disable cookies in your browser settings.
          </Typography>
        </Box>

        <Box sx={styles.section}>
          <Typography sx={styles.numberedHeading}>8. Your Rights</Typography>
          <Typography sx={styles.text}>
            You may request to:
          </Typography>
          <Box component="ul" sx={styles.list}>
            <li><Typography component="span" sx={styles.listItem}>Access your personal data</Typography></li>
            <li><Typography component="span" sx={styles.listItem}>Correct inaccurate information</Typography></li>
            <li><Typography component="span" sx={styles.listItem}>Request deletion of your data where legally permitted</Typography></li>
          </Box>
        </Box>

        <Box sx={styles.sectionLast}>
          <Typography sx={styles.numberedHeading}>9. Contact</Typography>
          <Typography sx={styles.text}>
            For privacy inquiries:
          </Typography>
          <Typography sx={styles.text}>
            Email:{' '}
            <Link href="mailto:contact@royal-vista.com" sx={styles.link}>
              contact@royal-vista.com
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;

